import ReactRailsUJS from "react_ujs";
import * as ActiveStorage from "@rails/activestorage";
import { viteConstructorRequireContext } from "../utils/viteConstructorRequireContext";

import "@/setup";
import "@/globals";

ActiveStorage.start();

// import react components
const componentsRequireContext = import.meta.glob("@components/**/*.{js,jsx}", {
  eager: true,
});

ReactRailsUJS.getConstructor = viteConstructorRequireContext(
  componentsRequireContext
);

// hide loading spinner and show main after initial load
// document.addEventListener("turbo:load", () => {
document.addEventListener("DOMContentLoaded", () => {
  const preloader = document.getElementById("preloader");
  const preloaderOverlay = document.getElementById("preloader-overlay");
  const main = document.getElementById("main");
  const footer = document.querySelector("footer");

  preloader.style.display = "none";
  preloader.style.opacity = 0;
  preloaderOverlay.style.display = "none";
  preloaderOverlay.style.opacity = 0;
  main.style.display = "block";
  footer.style.display = "block";
  setTimeout(() => {
    main.style.opacity = 1;
    footer.style.opacity = 1;
  }, 100);
});
